import Navbar from "./Navbar";
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Alert from "./Alert";
import "../styleSheets/mainLayout.css";

const MainLayout = ({ alert }) => {
  return (
    <div className="main-layout">
      <Navbar />
      <Alert alert={alert} />
      <Outlet />
    </div>
  );
};

export default MainLayout;
